// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._ahbq1ejb{margin-inline-start:var(--ds-space-300,24px)}
._ahbqxy5q{margin-inline-start:var(--ds-space-400,2pc)}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/datetime-picker/dist/esm/internal/indicators-container.compiled.css"],"names":[],"mappings":"AAAA,WAAW,4CAA4C;AACvD,WAAW,2CAA2C","sourcesContent":["._ahbq1ejb{margin-inline-start:var(--ds-space-300,24px)}\n._ahbqxy5q{margin-inline-start:var(--ds-space-400,2pc)}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
